import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { ATHENA } from "@/constants/testIds";

const links = [
  { label: "About", to: "about", id: ATHENA.navAbout },
  { label: "Domains", to: "domains", id: ATHENA.navDomains },
  { label: "Science", to: "science", id: ATHENA.navScience },
  { label: "Contact", to: "contact", id: ATHENA.navContact },
];

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#F8F7F4]/75 border-b border-[#D5D1C8]/60" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid={ATHENA.navLogo}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <span className="w-8 h-8 rounded-full border border-[#1A382A] flex items-center justify-center">
            <span className="w-2 h-2 rounded-full bg-[#1A382A] group-hover:bg-[#B89B64] transition-colors" />
          </span>
          <span className="font-display text-2xl tracking-tight text-[#0A1713] leading-none">
            Athena<span className="text-[#B89B64]">.</span>
          </span>
          <span className="hidden sm:inline-block label-mono ml-2 pl-3 border-l border-[#D5D1C8]">
            NUTRASCIENCE
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.to}
              data-testid={l.id}
              onClick={() => scrollTo(l.to)}
              className="link-underline text-sm font-medium text-[#0A1713]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid={ATHENA.navMobileToggle}
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-[#0A1713]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#D5D1C8]/60 bg-[#F8F7F4]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.to}
                data-testid={`${l.id}-mobile`}
                onClick={() => {
                  setOpen(false);
                  scrollTo(l.to);
                }}
                className="text-left text-base font-medium text-[#0A1713]"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
